import "./PageHeader.css";

export default function PageHeader({
  eyebrow = "POWER",
  title,
  description,
  actions,
}) {
  return (
    <div className="page-header">
      <div className="page-header__content">
        <span className="page-header__eyebrow">{eyebrow}</span>

        <h1>{title}</h1>

        {description && <p>{description}</p>}
      </div>

      {actions && <div className="page-header__actions">{actions}</div>}
    </div>
  );
}
